<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="70%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <fg-input
              :label="`${$t('common_words.name')}: *`"
              class="required-name"
              ref="name"
              type="text"
              v-model="model.name"
              v-validate="`required|max:35`"
              name="common_words.name"
              :error="getError('common_words.name', true)"
              :placeholder="`${$t('common_words.name')}`"
            >
            </fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-2`">
            <fg-input
              :label="`${$t('common_words.year')}: *`"
              class="required-year"
              type="number"
              v-model="model.year"
              name="common_words.year"
              v-validate="
                'required|integer|digits:4|min_value:1900|max_value:2100'
              "
              :error="getError('common_words.year', true)"
              :placeholder="`${$t('common_words.year')}`"
            >
            </fg-input>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.starting_date') }}: *</label>
            <br />
            <el-date-picker
              class="shadow-sm date-form"
              v-model="model.start_date"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.final_date') }}: *</label>
            <br />
            <el-date-picker
              class="shadow-sm date-form"
              v-model="model.end_date"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select')}...`"
            >
            </el-date-picker>
          </div>
          <div :class="`col-12`">
            <select-businesses-component
              ref="selectBusiness"
              :showLoading="true"
              @onChange="updateSelectedBusinesses"
              @showHideLoading="showHideLoading"
              :initialData="businessesInitial"
            />
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-type',
  mixins: [
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinValidations,
    MixinAlert,
    MixinPermissions,
  ],
  data() {
    return {
      model: {
        name: null,
        year: null,
        start_date: null,
        end_date: null,
        business_id: [],
        businesses_names: [],
      },
      businessesInitial: [],
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.business_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }

            return false;
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'business_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
